import React from "react";

import { useTranslation } from "utils";

import { SOIL_SIGHT_FEEDBACK_FORM_URL } from "consts";

import { Button, Icon, Typography } from "components";

export const openSoilSightFeedbackForm = () => window.open(SOIL_SIGHT_FEEDBACK_FORM_URL, "_blank", "noopener,noreferrer");

const OPEN_BETA_INFO_MIXPANEL_TEXT = "SoilSight beta: what it can and can't do";

// We use nav:beta for the pill text, because scenarioBuilder.beta is "New" in the en locale.
export const BetaBadge = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation("scenarioAnalysis");

  return (
    <button
      type="button"
      className="scenario-analysis-beta-badge soil-sight-beta-badge"
      onClick={onClick}
      aria-haspopup="dialog"
      data-testid="soil-sight-beta-badge"
    >
      {t("nav:beta")}
      <Icon iconName="tabler/info-circle" size="s" aria-hidden />
    </button>
  );
};

export const BetaCaveat = ({ onOpenBetaInfo }: { onOpenBetaInfo: () => void }) => {
  const { t } = useTranslation("scenarioAnalysis");

  return (
    <div className="soil-sight-beta-caveat" data-testid="soil-sight-beta-caveat">
      <Icon iconName="tabler/info-circle" size="s" aria-hidden />
      <Typography variant="paragraph-s" color="grey-600">
        {t("betaNotice.caveat")}{" "}
        <Button size="small" type="link" onClick={onOpenBetaInfo} mixpanelText={OPEN_BETA_INFO_MIXPANEL_TEXT} dataTestId="soil-sight-beta-caveat-link">
          {t("betaNotice.whatItCanDo")}
        </Button>
      </Typography>
    </div>
  );
};

export const BetaFooter = ({ onOpenBetaInfo }: { onOpenBetaInfo: () => void }) => {
  const { t } = useTranslation("scenarioAnalysis");

  const footerLinks = [
    {
      translationKey: "betaNotice.whatItCanDo",
      action: onOpenBetaInfo,
      mixpanelText: OPEN_BETA_INFO_MIXPANEL_TEXT,
      dataTestId: "soil-sight-beta-footer-about",
    },
    {
      translationKey: "betaNotice.giveFeedback",
      action: openSoilSightFeedbackForm,
      mixpanelText: "SoilSight beta: footer feedback",
      dataTestId: "soil-sight-beta-footer-feedback",
    },
  ];

  return (
    <footer className="soil-sight-beta-footer" data-testid="soil-sight-beta-footer">
      <span className="scenario-analysis-beta-badge soil-sight-beta-badge">{t("nav:beta")}</span>
      <Typography variant="paragraph-s" color="grey-600">
        {t("betaNotice.footer")}
      </Typography>
      <div className="soil-sight-beta-footer-links">
        {footerLinks.map((link) => (
          <Button key={link.translationKey} type="link" onClick={link.action} mixpanelText={link.mixpanelText} dataTestId={link.dataTestId}>
            {t(link.translationKey)}
          </Button>
        ))}
      </div>
    </footer>
  );
};
